import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <div className="relative bg-au-green text-white overflow-hidden" data-id="element-222">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-32 relative z-10" data-id="element-223">
        <div className="max-w-3xl" data-id="element-224">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold leading-tight mb-6" data-id="element-225">
            Advancing Africa's Global Partnerships for Sustainable Development
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          width: 0
        }} animate={{
          opacity: 1,
          width: 64
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="h-1 bg-au-gold mb-8" data-id="element-226" />

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-lg md:text-xl text-green-50 mb-10 leading-relaxed max-w-2xl" data-id="element-227">
            The African Union Commission connects Africa with partners across
            the world — driving transformative projects in health, education,
            trade, and infrastructure to foster prosperity and inclusive growth
            globally.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="flex flex-wrap items-center gap-6" data-id="element-228">
            <Link to="/projects" className="flex items-center text-white font-medium hover:text-au-gold transition-colors group focus:outline-none focus:ring-2 focus:ring-au-gold focus:ring-offset-2 focus:ring-offset-au-green rounded-sm" data-id="element-229">
              Explore Our Projects
              <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-230" />
            </Link>
            <Link to="/bids" className="bg-white text-au-green px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-au-green" data-id="element-231">
              View Current Bids
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-10 pointer-events-none" data-id="element-232">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full" fill="currentColor" data-id="element-233">
          <path d="M0 100 L100 0 L100 100 Z" data-id="element-234" />
        </svg>
      </div>

      {/* Bottom Gold Strip */}
      <div className="absolute bottom-0 left-0 w-full h-2 bg-au-gold" data-id="element-235" />
    </div>;
}